import * as React from 'react'

import { observer } from 'mobx-react'

import GeneralMapPopup, {
  MapPopupBody,
} from '~/client/src/shared/components/MapPopups/GeneralMapPopup'

import StackList, { IStackListProps, StackListHeader } from './StackList'

interface IProps extends IStackListProps {
  latitude: number
  longitude: number
  // Clearance from the stacked marker, as GeneralMapPopup takes it.
  offset?: number
}

// localization: no text to translate

// The popup's own close is not the list's: mapbox also fires it when the map is torn down (a
// switch to a whiteboard), which would close a stack the derived visibility means to bring back.
// The header's close and any map click put the list away instead.
const NOOP = () => undefined

@observer
export default class StackMapPopup extends React.Component<IProps> {
  public render() {
    const { latitude, longitude, offset, ...listProps } = this.props
    const { rows, workflows, getLocation, onClose } = listProps

    return (
      <GeneralMapPopup
        item={null}
        coordOverride={{ latitude, longitude }}
        offset={offset}
        isOffsetCentred
        onClose={NOOP}
        closeOnMapClick={false}
        focusAfterOpen={false}
        customHeader={
          <StackListHeader
            rows={rows}
            workflowCount={workflows.length}
            getLocation={getLocation}
            onClose={onClose}
          />
        }
      >
        <MapPopupBody>
          <StackList {...listProps} focusesFirstRow />
        </MapPopupBody>
      </GeneralMapPopup>
    )
  }
}
